import { Survey_Location_Statistics_Sort_By } from '@occc/graphql';

import { useSortingParams as useSortingParamsImported } from '../../../hooks/useSortingParams';
import {
  SURVEY_LOCATION_SORT_DIRECTION_PARAM,
  SURVEY_LOCATION_SORT_FIELD_PARAM,
  SURVEY_LOCATIONS_AFTER_PARAM,
  SURVEY_LOCATIONS_BEFORE_PARAM,
} from '../constants';

export const useSurveyLocationSortingParams = () => {
  return useSortingParamsImported<Survey_Location_Statistics_Sort_By>({
    sortFieldParamName: SURVEY_LOCATION_SORT_FIELD_PARAM,
    sortDirectionParamName: SURVEY_LOCATION_SORT_DIRECTION_PARAM,
    beforeParamName: SURVEY_LOCATIONS_BEFORE_PARAM,
    afterParamName: SURVEY_LOCATIONS_AFTER_PARAM,
    initialValues: {
      field: Survey_Location_Statistics_Sort_By.TotalResponses,
      direction: 'desc',
    },
  });
};
